import clsx from 'clsx'
import { FC } from 'react'
import { ClassName } from 'types/props'

import classes from './index.module.scss'

export const Centered: FC<ClassName> = ({ children, className }) => (
  <div className={clsx(classes.root, className)}>{children}</div>
)
